module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAQCAYAAAAxtt7zAAAANElEQVQoU2M8e/Zs+v///1sYGBhYGBgYChjPnDnznoGBQYABAt5gCmBogSqFU4wYAkPGFgAlokJ9ZF0rmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/index/1013213.png
// module id = Yfbm
// module chunks = 1